import React from 'react';
import { Box, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';

export default function CitasClienteTabla({ citas }) {
  if (!citas || citas.length === 0) {
    return (
      <Typography variant="body2" sx={{ color: 'text.secondary', fontStyle: 'italic', py: 2 }}>
        No hay citas registradas para este cliente.
      </Typography>
    );
  }

  return (
    <Box sx={{ overflowX: 'auto', border: '1px solid #E2E8F0', borderRadius: '8px', mt: 1 }}>
      <Table size="small">
        <TableHead sx={{ backgroundColor: '#0F172A' }}>
          <TableRow>
            <TableCell sx={{ color: '#FFF', fontWeight: 'bold' }}>Fecha</TableCell>
            <TableCell sx={{ color: '#FFF', fontWeight: 'bold' }}>Hora</TableCell>
            <TableCell sx={{ color: '#FFF', fontWeight: 'bold' }}>Sala / ROOM</TableCell>
            <TableCell sx={{ color: '#FFF', fontWeight: 'bold' }}>Servicio / Treatment</TableCell>
            <TableCell sx={{ color: '#FFF', fontWeight: 'bold' }}>Terapeuta / Recepción</TableCell>
            <TableCell sx={{ color: '#FFF', fontWeight: 'bold' }}>Comentario</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {citas.map((c, i) => (
            <TableRow key={c.id || i} hover sx={{ '&:nth-of-type(even)': { backgroundColor: '#F8FAFC' } }}>
              <TableCell sx={{ fontWeight: 600 }}>{c.fecha || '-'}</TableCell>
              <TableCell>{c.hora || '-'}</TableCell>
              <TableCell>{c.sala || '-'}</TableCell>
              <TableCell sx={{ fontWeight: 500, color: '#1E293B' }}>{c.servicio || '-'}</TableCell>
              <TableCell>{[c.terapeuta, c.recepcion].filter(Boolean).join(' / ') || '-'}</TableCell>
              <TableCell sx={{ color: '#64748B', fontStyle: 'italic' }}>{c.comentario || '-'}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Box>
  );
}
